"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StockStatus;

var _react = _interopRequireDefault(require("react"));

function StockStatus(props) {
  function displayStockStatus() {
    if (props.qoh.on_orders >= props.qtyOnThisOrder && props.qoh.available < 0) {
      return /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          color: 'red',
          position: 'inline'
        }
      }, "Out of stock");
    }

    return /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        position: 'inline'
      }
    }, "In stock");
  }

  if (props.show) {
    return displayStockStatus();
  }

  return null;
}